import React from 'react';

export const AccountIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0001 10.0001C11.8401 10.0001 13.3334 8.50681 13.3334 6.66681C13.3334 4.82681 11.8401 3.33348 10.0001 3.33348C8.16007 3.33348 6.66675 4.82681 6.66675 6.66681C6.66675 8.50681 8.16007 10.0001 10.0001 10.0001ZM10.0001 11.6668C7.77925 11.6668 3.33341 12.7793 3.33341 15.0001V16.6668H16.6667V15.0001C16.6667 12.7793 12.221 11.6668 10.0001 11.6668Z"
      fill="currentColor"
    />
  </svg>
);
